<template>
  <div class="wscn-http404-container">
    <div class="wscn-http404">
      <div class="pic-404">
        <img class="pic-404__parent" src="../../assets/img/404/404.png" alt="404">
        <img class="pic-404__child left" src="../../assets/img/404/404_cloud.png" alt="404">
        <img class="pic-404__child mid" src="../../assets/img/404/404_cloud.png" alt="404">
        <img class="pic-404__child right" src="../../assets/img/404/404_cloud.png" alt="404">
      </div>
      <div class="bullshit">
        <!-- <div class="bullshit__oops">OOPS!</div> -->
        <div class="bullshit__headline">哎呀！找不到页面了 …</div>
        <span class="bullshit__return-home" @click="goS()">返回首页</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: 'Page404',
  data(){
    return{
      to:''
    }
  },
  methods:{
    ...mapActions([
      'saveLogUrl'
    ]),
    goS(){
      this.saveLogUrl({logUrl:'/home'});
      this.$router.push('/home');
    }
  }
}
</script>

<style  scoped>
.wscn-http404-container{
  transform: translate(-45%,-45%);
  position: absolute;
  top: 40%;
  left: 50%;
}
.wscn-http404 {
  position: relative;

  overflow: hidden;
}
.pic-404 {
  position: relative;
  width: 600px;
  overflow: hidden;
}
.pic-404__parent {
  width: 100%;
}
.pic-404__child {
  position: absolute;
}

.left {
  width: 80px;
  top: 17px;
  left: 220px;
  opacity: 0;
  animation-name: cloudLeft;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1s;
}
.mid {
  width: 46px;
  top: 10px;
  left: 420px;
  opacity: 0;
  animation-name: cloudMid;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1.2s;
}
.right {
  width: 62px;
  top: 100px;
  left: 500px;
  opacity: 0;
  animation-name: cloudRight;
  animation-duration: 2s;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  animation-delay: 1s;
}
@keyframes cloudLeft {
  0% {
    top: 17px;
    left: 220px;
    opacity: 0;
  }
  20% {
    top: 33px;
    left: 188px;
    opacity: 1;
  }
  80% {
    top: 81px;
    left: 92px;
    opacity: 1;
  }
  100% {
    top: 97px;
    left: 60px;
    opacity: 0;
  }
}
@keyframes cloudMid {
  0% {
    top: 10px;
    left: 420px;
    opacity: 0;
  }
  20% {
    top: 40px;
    left: 360px;
    opacity: 1;
  }
  70% {
    top: 130px;
    left: 180px;
    opacity: 1;
  }
  100% {
    top: 160px;
    left: 120px;
    opacity: 0;
  }
}
@keyframes cloudRight {
  0% {
    top: 100px;
    left: 500px;
    opacity: 0;
  }
  20% {
    top: 120px;
    left: 460px;
    opacity: 1;
  }
  80% {
    top: 180px;
    left: 340px;
    opacity: 1;
  }
  100% {
    top: 200px;
    left: 300px;
    opacity: 0;
  }
}
.bullshit {
  position: relative;
  /* width: 339px; */
   margin:0 auto;
   text-align: center;
  padding: 42px 0;
  overflow: hidden;
}
.bullshit__oops {
  font-size: 32px;
  font-weight: bold;
  line-height: 40px;
  color: #1482f0;
  opacity: 0;
  margin-bottom: 20px;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}
.bullshit__headline {
  font-size: 20px;
  line-height: 24px;
  color: #333;
  font-weight: bold;
  opacity: 0;
  margin-bottom:34px;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-delay: 0.1s;
  animation-fill-mode: forwards;
}
.bullshit__info {
  font-size: 13px;
  line-height: 21px;
  color: grey;
  opacity: 0;
  margin-bottom: 30px;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-delay: 0.2s;
  animation-fill-mode: forwards;
}
.bullshit__return-home {
  display: inline-block;
  width: 130px;
  height: 38px;
  background: #1890FF ;
  border-radius: 100px;
  text-align: center;
  color: #ffffff;
  opacity: 0;
  font-size: 14px;
  line-height: 38px;
  cursor: pointer;
  animation-name: slideUp;
  animation-duration: 0.5s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
}
@keyframes slideUp {
  0% {
    transform: translateY(60px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/publicComponents/notFound.vue